module.exports = __webpack_public_path__ + "img/s4-2-ja.c2a42fc1.jpg";